export const styles = {
  title: {
    fontSize: 20,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
    fontWeight: '700',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 20,
  },
  columnHeader: {
    marginBottom: 20,
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#707087',
    fontWeight: '500',
  },
  columnValue: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
  },
  userLink: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#011533',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  buttonContainer: {
    height: 70,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  button: {
    height: 32,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#E2E2FC',
    },
  },
  link: {
    fontFamily: "'Proxima Nova Alt', sans-serif",
    fontSize: 16,
    fontWeight: '700',
    color: '#011533',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  arrowButton: {
    marginRight: 10,
    cursor: 'pointer',
  },
}
